export default __webpack_public_path__ + "0792ef129811f27b9de85523a3f9430f.png";